/* Product Tag Filters - Good for any number of filters on any type of collection page.
Give you product tag filter select element a class of coll-filter.
Give your collection select a class of coll-picker.
Brought to you by Caroline Schnapp. */
// shopify code to store select filter 
//console.log("Working");

function getURLParameter(name) {
  return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search)||[,""])[1].replace(/\+/g, '%20'))||null;
}


function changeUrlParam (param, value) {
  var currentURL = window.location.href+'&';
  var change = new RegExp('('+param+')=(.*)&', 'g');
  var newURL = currentURL.replace(change, '$1='+value+'&');

  if (getURLParameter(param) !== null){
    try {
      window.history.replaceState('', '', newURL.slice(0, - 1) );
    } catch (e) {
      console.log(e);
    }
  } else {
    var currURL = window.location.href;
    if (currURL.indexOf("?") !== -1){
      window.history.replaceState('', '', currentURL.slice(0, - 1) + '&' + param + '=' + value);
    } else {
      window.history.replaceState('', '', currentURL.slice(0, - 1) + '?' + param + '=' + value);
    }
  }
}


Shopify.queryParams = {};
if (location.search.length) {
  for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
    aKeyValue = aCouples[i].split('=');
    if (aKeyValue.length > 1) {
      Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
    }
  }
}
// **************Code to apply filter********************//

// code to apply sidebar filter 
var collFilters = jQuery('.widget-content li label');
collFilters.click(function() {
  delete Shopify.queryParams.page;

  //current input[type=checkbox] checked variable 
  var current_filter = $(this).parent().find('input[type=checkbox]:checked');
  var filter_under_section = $(this).parent().parent().find('input[type=checkbox]:checked');

  // checking the input[type=checkbox] is checked or not in current filter, if checked removing it using prop() method
  if(current_filter){
    $(current_filter).prop("checked", false);
    $(current_filter).addClass('warn-input')
    // alert('working');
  }

  // checking the input[type=checkbox] is checked or not in entire section, if checked removing it  and adding checked attribute to current input using prop() method 
  if(filter_under_section){
    

    
    $(this).parent().find('input[type=checkbox]').not('.warn-input').prop("checked", true);
  }
  // call function for filter
  sidebarFilter();
});

function sidebarFilter(){
  // creating a array variable
  var newTags = [];

  collFilters.each(function() {
    // storing input[type=checkbox] of different different filter in variable using each() method
    var checkbox_condition = $(this).parent().parent().find('input[type=checkbox]');
    // storing checked checkbox of different different filter in variable using each() method
    var checkbox_checked_value=$(this).parent().parent().find('input[type=checkbox]:checked');
    // if condition to varify input[type=checkbox] is checked or not 
    if(checkbox_condition.is(':checked')){
      // if codition to varify that checked input[type=checkbox] has value or not
      if (checkbox_checked_value.val()) {
        // if input[type=checkbox] value already available in array, 
        if(newTags.indexOf( checkbox_checked_value.val() )>=0){
          //then keep the array as it is, 
        }else{
          // else add input[type=checkbox] value to the array
          newTags.push(checkbox_checked_value.val());
        }
      }
    }
    // alert(newTags);
  });
  // if condition to check collection handle 
  
  if (newTags.length) {
    Shopify.queryParams.constraint = newTags.join('+');
  }
  else {
    delete Shopify.queryParams.constraint;
  }
  location.search = jQuery.param(Shopify.queryParams);
  

}
// ******************Code to apply filter end********************//
// ******************Code to clear filter********************//
var collFilters = jQuery('.widget-title h3 a');
collFilters.click(function() {
  delete Shopify.queryParams.page;

  //current input[type=checkbox] checked variable 
  var current_filter = $(this).parents('aside').find('input[type=checkbox]:checked');

  // checking the input[type=checkbox] is checked or not in current filter, if checked removing it using prop() method
  if(current_filter){
    $(current_filter).prop("checked", false);
    $(current_filter).addClass('warn-input')
    // alert('working');
  }
  // call function for filter
  sidebarFilter();
});

function sidebarFilter(){
  // creating a array variable
  var newTags = [];

  collFilters.each(function() {
    // storing checked checkbox of different different filter in variable using each() method
    var checkbox_checked_value=$(this).parents('aside').find('input[type=checkbox]:checked');
    // if codition to varify that checked input[type=checkbox] has value or not
    if (checkbox_checked_value.val()) {
      // if input[type=checkbox] value already available in array, 
      if(newTags.indexOf( checkbox_checked_value.val() )>=0){
        //then keep the array as it is, 
      }else{
        // else add input[type=checkbox] value to the array
        newTags.push(checkbox_checked_value.val());
      }
    }
  });
  // if condition to check collection handle 
  
  if (newTags.length) {
    Shopify.queryParams.constraint = newTags.join('+');
  }
  else {
    delete Shopify.queryParams.constraint;
  }
  location.search = jQuery.param(Shopify.queryParams);
  

}

// **************Code to clear filter end********************//
// **************product slider section js********************//
jQuery(document).ready(function($){

  // set with of mega menu
  var pc_navigation_width = $('.site-nav').width();
  $('.mega-menu').css('width',pc_navigation_width+'px');

  //  close cart on black background click
  $('.js-drawer-open .black_background').click(function(){
    $('body').trigger('click');
  });

  // homepage main image slider 
  $('.flexslider').flexslider({
    animation: "slide",
    start: function(slider){
      $('body').removeClass('loading');
    }
  });

  // owl carousel code for homepage product slider
  $('.owl-carousel').owlCarousel({
    items:4,
    navigation : true,
    itemsTablet: [768,3],
    itemsTabletSmall: [650,2],
    itemsMobile:[479,2]
  });

  // owl carousel code for related product slider
  $("#owl-demo").owlCarousel({
    items:4,
    navigation : true,
    itemsTablet: [768,3],
    itemsTabletSmall: [650,2],
    itemsMobile:[479,2]
  });

  // owl carousel code for PDP Page
  $("#product-thumbnails-slider").owlCarousel({
    items:4,
    navigation : true,
    itemsTablet: [768,3],
    itemsTabletSmall: [650,2],
    itemsMobile:[479,3]
  });
  // When the user scrolls down 20px from the top of the document, show the button
  window.onscroll = function() {scrollFunction()};

  function scrollFunction() {
    if (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20) {
      document.getElementById("myBtn").style.display = "block";
    } else {
      document.getElementById("myBtn").style.display = "none";
    }
  }

  // When the user clicks on the button, scroll to the top of the document
  function topFunction() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;

    jQuery('html, body').animate({
      scrollTop: target.offset().top
    }, 1000); 
  }
  //   fixed navigation on window scroll
  var wrap = $("#PageContainer");
  window.onscroll = function() {addClassOn()};
  function addClassOn() {
    if (document.body.scrollTop > 200 || document.documentElement.scrollTop > 200) {
      wrap.addClass("on");
    } else {
      wrap.removeClass("on");
    }
  }
  //   code to change product image on click of thumbnil on detail page
  $('#product-thumbnails-slider li a').click(function(){
    var product_image = $(this).attr('data-image');
    //     alert(product_image);
    $('#ProductPhotoImg').attr('src',product_image);
    $('#ProductPhotoImg').attr('data-image',product_image);
  });
  //   
  $(".zoom_mw").elevateZoom({
    gallery: 'product-thumbnails-slider',
    cursor: 'pointer',
    galleryActiveClass: 'active',
    imageCrossfade: false,
    scrollZoom: true
  });
});